import { Ajax } from './axios';
// 报名
export default {
  // 退款订单列表
  listRefundGet () {
    return Ajax.get('/api/gugongExaminee/v1/trade/listRefund');
  },
  // 撤销退款订单
  cancelRefundGet (refundOrderId) {
    return Ajax.get(`/api/gugongExaminee/v1/trade/cancelRefund/${refundOrderId}`);
  },
  // 获取订单详情
  tradeDetailGet (orderId) {
    return Ajax.get(`/api/gugongExaminee/v1/trade/${orderId}`);
  },
  // 获取详情列表
  refundDetailGet (refundOrderId) {
    return Ajax.get(`/api/gugongExaminee/v1/trade/refundDetail/${refundOrderId}`);
  }, 
  // 修改退款申请 post /{version}/trade/applyRefund
  applyRefundPost (param = {}) {
    return Ajax.post(`/api/gugongExaminee/v1/trade/applyRefund`, { ...param });
  },
  // 修改退款申请 PUT /{version}/trade/updateRefundApply
  updateRefundApplyPut (param = {}) {
    return Ajax.put(`/api/gugongExaminee/v1/trade/updateRefundApply`, { ...param });
  }
}
